import { Route } from '@angular/router';
import { DocRequestComponent } from './docRequest.component';

export const DocRequestRoutes: Route[] = [
  {
    path: 'doc-request/:code',
    component: DocRequestComponent
  }
];
